import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/albumConfigPage.css'
import i18n from '@/locales'
import { initElementPlusLocale } from '@/composables/useAppLocale'
import { readStoredLocale } from '@/constants/locale'
import { vPermission } from '@/directives/permission'

async function bootstrap () {
  await initElementPlusLocale(readStoredLocale())

  const app = createApp(App)

  app.use(i18n)
  app.use(router)
  app.use(store)
  app.use(ElementPlus)
  app.directive('permission', vPermission)

  app.mount('#app')
}

bootstrap()
